jQuery(document).ready(function ($) { 

    // Title Decorations
    $('.title-decoration').each(function () {
        var $this = $(this),
            thisText = $this.text();

        if (!$this.find('span').length > 0) {
            $this.text('');
            $this.append('<span></span>');
            $this.find('span').text(thisText);
        }
    });
    $('.title-decoration-main h2, .title-decoration-main h3').each(function () {
        var $this = $(this),
            thisText = $this.text();

        if (!$this.find('span').length > 0) {
            $this.text('');
            $this.append('<span></span>');
            $this.find('span').text(thisText);
        }
    });


    if($('.animated-form')) {
        $('.animated-form input').on('focusin', function() {
            $(this).parent().parent().find('label').addClass('active');
        });
        
        $('.animated-form input').on('focusout', function() {
            if( !$(this).val() ) {
                $(this).parent().parent().find('label').removeClass('active');
            }
        });
        $('.animated-form .gfield input').each(function() {
            if( $(this).val() ) {
                $(this).parent().parent().find('label').addClass('active'); 
            }
        });
    }
});